// import { BarDatum } from '@nivo/bar'
import { LineSeries } from '@nivo/line'

export const COLOR_SCHEME_SET1_PLUS1 = [
  '#0000FF',
  '#E41A1CFF',
  '#377EB8FF',
  '#4DAF4AFF',
  // '#984EA3FF',
  '#FF7F00FF',
  '#FFFF33FF',
  '#A65628FF',
  '#F781BFFF',
  '#999999FF',
]

export const COLOR_SCHEME_SET1 = [
  '#E41A1CFF',
  '#377EB8FF',
  '#4DAF4AFF',
  // '#984EA3FF',
  '#FF7F00FF',
  '#FFFF33FF',
  '#A65628FF',
  '#F781BFFF',
  '#999999FF',
]

export enum CalibrationChartType {
  Line = 0,
  Bar = 1,
}

export interface CustomSeries extends LineSeries {
  lineType?: CustomLineType
  lineWidth?: number
  lineColor?: string
  areaFill?: boolean
  areaFillColor?: string
  stacked?: boolean
}

export const defaultCustomSeries = (id: string): CustomSeries => ({
  id,
  data: [],
})

export type CustomLineType = {
  name: string
  strokeDashArray?: number[]
}

export const CustomLineStyles: Record<string, CustomLineType> = {
  Dotted: {
    name: 'dotted',
    strokeDashArray: [10, 5],
  },
  Solid: {
    name: 'solid',
  },
}

const graphItem = (
  xValue: number | string,
  yValue: number | null,
): { x: number | string; y: number | null } => ({
  x: xValue,
  y: yValue,
})

export const createChartSerie = (
  seriesId: string,
  xValues: number[] | string[],
  yValues: (number | null)[],
  lineType = CustomLineStyles.Solid,
  lineWidth = 1,
  stacked = false,
): CustomSeries => {
  const data = Array(xValues.length).fill({})

  for (let i = 0; i < data.length; i++) {
    data[i] = graphItem(xValues[i], yValues[i])
  }

  return {
    id: seriesId,
    lineType,
    lineWidth,
    data,
    stacked,
  }
}

export const createDefaultLineChartSerie = (
  seriesId: string,
  xValues: number[],
  lineType = CustomLineStyles.Solid,
  lineWidth = 1,
  stacked = false,
): CustomSeries => {
  const data = Array(xValues.length).fill({})

  for (let i = 0; i < data.length; i++) {
    data[i] = graphItem(xValues[i], 0)
  }

  return {
    id: seriesId,
    lineType,
    lineWidth,
    data,
    stacked,
  }
}

export const createChartSerieValues = (
  xValues: number[],
  yValues: (number | null)[],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any[] => {
  const data = Array(xValues.length).fill({})

  for (let i = 0; i < data.length; i++) {
    data[i] = graphItem(xValues[i], yValues[i])
  }

  return data
}

// export const createDefaultBarChartSerie = (
//   seriesId: string,
//   xValues: string[] | number[],
// ): BarDatum[] => {
//   const data: BarDatum[] = []

//   xValues.forEach((_, index) => {
//     data.push({ id: xValues[index] })
//   })

//   return data
// }
